import { MentionData } from '@draft-js-plugins/mention'

export default function buildEntities(value: string | undefined, mentions: MentionData[]) {
  const rawEntities = {}
  const selectedMentions: MentionData[] = []
  mentions?.forEach((mention: MentionData) => {
    if (value?.toString().includes(mention.name.trim())) {
      const rawEntity = {
        type: 'mention',
        mutability: 'IMMUTABLE',
        data: { mention }
      }
      // @ts-expect-error
      rawEntities[mention.name] = rawEntity
      selectedMentions.push(mention)
    }
  })
  return [rawEntities, selectedMentions] as const
}
